import { render, staticRenderFns } from "./InsightForm.vue?vue&type=template&id=3c686fca"
import script from "./InsightForm.vue?vue&type=script&lang=js"
export * from "./InsightForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c686fca')) {
      api.createRecord('3c686fca', component.options)
    } else {
      api.reload('3c686fca', component.options)
    }
    module.hot.accept("./InsightForm.vue?vue&type=template&id=3c686fca", function () {
      api.rerender('3c686fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Insight/InsightForm.vue"
export default component.exports